module.exports = __webpack_public_path__ + "static/media/write.7f0509a6.svg";